import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const { googleSession } = useAuth();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) {
        navigate("/login");
        return;
      }
      try {
        const u = await googleSession(sessionId);
        navigate(u.role === "admin" ? "/admin" : "/dashboard", { replace: true });
      } catch {
        navigate("/login?error=google");
      }
    })();
  }, [googleSession, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-navy text-white">
      <div className="text-center">
        <div className="mx-auto h-10 w-10 animate-spin rounded-full border-2 border-white/20 border-t-aero" />
        <p className="mt-4 text-sm text-white/70">Signing you in…</p>
      </div>
    </div>
  );
}
